const streamers = [
	{
		path: '/tv/streamers/list',
		name: 'tv-streamers-list',
		component: () => import('@/views/tv/streamers/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,streamers',
		},
	},
	{
		path: '/tv/streamers/applications/list',
		name: 'tv-streamers-applications-list',
		component: () => import('@/views/tv/streamers/applications/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,streamers',
		},
	},
	{
		path: '/tv/streamers/types/list',
		name: 'tv-streamers-types-list',
		component: () => import('@/views/tv/streamers/types/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,streamers',
		},
	},
	{
		path: '/tv/streamers/official-seal/list',
		name: 'tv-official-seal-list',
		component: () => import('@/views/tv/streamers/official-seal/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,streamers',
		},
	},
]

export default streamers
